'use client';
import { direction, Product, productCardType, ResponseType } from '@/commonTypes';
import { useSearchParams } from 'next/navigation';
import React, { useEffect, useState } from 'react';
import styles from './styles.module.css';
import useWindowDimensions from '@/functions/useWindowDimensions';
import { useLayoutContext } from '@/context/LayoutContext';
import ShopApi from '@/api/shop';
import { useTranslations } from 'next-intl';
import AttributeSection from './AttributeSection';
import ProductsServicesContent from './productsServicesTemplate';
import { mockProduct, mockProductCategory } from '@/mock/sample.json';
interface ContentType {
  data?: ResponseType<productCardType>;
  page?: string | number | null;
  limit?: number;
  params?: any;
  // category?: ResponseType<category>;
  activeCategory?: string | null;
  tagSlug?: string | null;
  type?: 'products' | 'services';
}

export default function ProductsContent({
  data,
  page,
  limit = 10,
  params,
  // category,
  activeCategory = '',
  tagSlug,
  type = 'products',
}: ContentType) {
  const tCommon = useTranslations('common');
  const [direction, setDirection] = useState<direction>('vertical');

  const sample = mockProduct;
  const initial = Array.from({ length: 10 }, (_, index) => ({
    ...sample,
    id: index + 1,
    randomNumber: Math.floor(Math.random() * 360),
    shop: {
      ...sample.shop,
      id: index % 2 === 0 ? 1 : 2,
    },
    count: index,
  }));

  const [pageNumber, setPageNumber] = useState<number | string>(page ? Number(page) : 1);
  const [list, setList] = useState({ response: initial, response_details: { count: 20 } });
  const [categoryList, setCategoryList] = useState(mockProductCategory);
  useEffect(() => {
    ShopApi.categoryList({ start: 0, limit: 1000 })
      .then((res) => {
        setCategoryList(res?.data?.response);
      })
      .catch((err) => {
        console.error('categoryList failed:', err);
      });
  }, []);

  const info = {
    breadcrumb: {
      items: [{ label: 'خانه', to: '/' }, { label: 'فروشگاه', to: '/shops' }, { label: 'محصولات' }],
    },
    hero: {
      title: 'فروشگاه‌های خودرویی اطراف شما',
      text: ' قطعات و لوازم جانبی معتبر از فروشگاه‌های نزدیک، با ارسال سریع و پرداخت امن کارا.',
    },
    category: {
      title: tCommon('category'),
    },
  };
  // const [list, setList] = useState(changeData(data));

  // useEffect(() => {
  //   if (data) {
  //     setList(changeData(data));
  //   }
  // }, [data]);
  useEffect(() => {
    setPageNumber(page ? page : 1);
  }, [page]);

  console.log('params1========', params);
  console.log('list==', list);

  return (
    <ProductsServicesContent
      pageNumber={pageNumber}
      setPageNumber={setPageNumber}
      categoryList={categoryList}
      direction={direction}
      setDirection={setDirection}
      infiniteApi={ShopApi.productList}
      limit={limit}
      list={list}
      setList={setList}
      params={params}
      page={page}
      type={type}
      initialList={data}
      info={info}
    />
  );
}
